import React from 'react';
// import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import LogoIcon from './images/logo.svg';

const useStyles = makeStyles(() => ({
  root: {},
  title: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 19,
  },
  logo: {
    height: 16,
    marginTop: 24,
  },
}));

function Success({ data }) {
  const { header } = data;
  const classes = useStyles();
  return (
    <Box display="flex" flexDirection="column">
      <Box component="div">
        <Typography className={classes.title}>{header}</Typography>
      </Box>
      <Box component="div" display="flex">
        <img src={LogoIcon} alt="" className={classes.logo} />
      </Box>
    </Box>
  );
}

export default Success;
